var scrollHandler = (function() {
	'use strict';

	var controller;
	var workScene;

	function init() {
		controller = new ScrollMagic.Controller();

		workScene = new ScrollMagic.Scene({
			triggerElement: $('.button--load-more')[0],
			triggerHook: "onEnter",
			offset: 0
		});

		controller.addScene([workScene]);

		init_events();
	}

	function init_events() {
		workScene.on('update', function(e) {
			// If the load more button is showing, and you scroll up, load more.
			if (isScrolledIntoView($('.button--load-more')[0])) {
				$('.button--load-more').click();
			}
		});
	}

	function destroy() {
		controller.destroy();
		controller = null;
		workScene.destroy();
	}

	function isScrolledIntoView(elem) {
		var $elem = $(elem);
		if ($elem.length != 0) {
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();

			var elemTop = $elem.offset().top;
			var elemBottom = elemTop + $elem.height();

			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
	}

	return {
		init:init,
		destroy:destroy
	};
}());
